import { Grid } from '@mui/material'
import PaymentDialogMobileContent from '../PaymentDialogMobileContent'
import CalculatePanel from 'components/Sell/CalculationInput/CalculatePanel'
import PaymentMobileDetail from '../PaymentMobileDetail'
import FinishPaymentButton from '../FinishPaymentButton'
import usePaymentContext from 'components/Sell/payment/hook/usePaymentContext'
import { usePaymentCalculation } from 'components/Sell/payment/hook/usePaymentCalculation'
import { useCallback, useState } from 'react'
import { t } from 'i18next'
import { EvoPaymentDialog } from 'components/Sell/payment/dialogs/EvoPaymentDialog'
import { useConfirmDialog } from 'store/actions/ui.action'

function EvoMobilePayment({
    onBack,
    onSubmitPayment,
}: {
    onBack: () => void
    onSubmitPayment: () => void
}) {
    const {
        selectedPaymentType,
        expectAmount,
        payment,
        isReadyToProceedPayment,
        onOpenAccountDialog,
        paymentDetail,
        tenderedAmount,
        onSetReceivedCash,
        onSetTenderedAmount,
        resetPaymentStatus,
        hasAwaitingProcessTransaction,
        resetEvoPaymentDialogState,
    } = usePaymentContext()

    const { isMoneyCollect } = usePaymentCalculation({
        selectedPaymentType,
        expectAmount,
        payment,
    })

    const { showConfirmDialog } = useConfirmDialog()
    const [openEvoDialog, setOpenEvoDialog] = useState(false)

    const onEvoDialogOpen = useCallback(async () => {
        const OpenDialog = () => {
            resetPaymentStatus()
            setOpenEvoDialog(true)
        }
        if (hasAwaitingProcessTransaction)
            showConfirmDialog(
                t('sell.payment_dialog.message.pending_integration_left'),
                (res) => {
                    if (res) OpenDialog()
                },
                t('sell.payment_dialog.confirm_title'),
            )
        else OpenDialog()
    }, [hasAwaitingProcessTransaction, resetPaymentStatus, showConfirmDialog])

    const onEvoDialogClose = useCallback(() => {
        setOpenEvoDialog(false)
        if (resetEvoPaymentDialogState) {
            resetEvoPaymentDialogState()
        }
    }, [resetEvoPaymentDialogState])

    return (
        <PaymentDialogMobileContent
            onBack={onBack}
            topSection={
                <Grid container direction="column" spacing={1}>
                    <Grid item>
                        <CalculatePanel
                            paymentDetail={paymentDetail}
                            initialValue={tenderedAmount.toNumber()}
                            onChange={(amount) => {
                                onSetReceivedCash(amount)
                                onSetTenderedAmount(amount)
                            }}
                            onChangeCustomerAccount={onOpenAccountDialog}
                            hideQuickButtons
                            minValue={0}
                        />
                    </Grid>
                    <EvoPaymentDialog
                        openDialog={openEvoDialog}
                        onClose={() => onEvoDialogClose()}
                        amount={expectAmount.toNumber()}
                        onPaid={onSubmitPayment}
                    />
                </Grid>
            }
            bottomSection={<PaymentMobileDetail />}
            finishButton={
                <FinishPaymentButton
                    onConfirm={onEvoDialogOpen}
                    onCancel={onBack}
                    isMoneyCollect={isMoneyCollect}
                    isReadyToProceedPayment={isReadyToProceedPayment}
                    confirmText={t('sell.payment_dialog.proceed_payment')}
                />
            }
        />
    )
}
export default EvoMobilePayment
